import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-033aef8a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "font-h6 title"
}, "Notification", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font-caption1 desc"
}, " Please note that the currency of base value will be changed from ETH to USDC when minting. By proceeding you agree to the conversion of the currency. ", -1));

const _hoisted_4 = {
  class: "row"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, " Cancel ", -1));

const _hoisted_6 = [_hoisted_5];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Confirm ", -1));

const _hoisted_8 = [_hoisted_7];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_common_modal = _resolveComponent("common-modal");

  return _openBlock(), _createBlock(_component_common_modal, {
    name: "confirm-mint"
  }, {
    content: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      class: "buttom-cancel-wrapper",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args))
    }, _hoisted_6), _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = (...args) => $options.confirm && $options.confirm(...args)),
      class: "buttom-confirm-wrapper"
    }, _hoisted_8)])])]),
    _: 1
  });
}